import { render } from "./index.vue?vue&type=template&id=e1dd88fe&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=e1dd88fe&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-e1dd88fe"

export default script